import { Link } from "react-router-dom";
import { ROUTES } from "../../../constants/routes";
import { getUserName } from "../../../helpers";
import ProfileImageComp from "../../common/profile";
import { useAppSelector } from "../../../hooks/store-hooks";

const UserLeftBar = () => {
  const { userData: user } = useAppSelector((state) => state?.user || {});
  return (
    <div className="lg:col-span-3 bg-white rounded-[12px] border h-fit pb-5">
      <div className="h-14 bg-blue-200 relative rounded-t-[10px]">
        {user?.banner ? (
          <img
            src={user.banner}
            alt="Background"
            className="w-full h-full rounded-t-[10px] object-cover"
          />
        ) : (
          <div className="w-full h-40 bg-[#007AFF]"></div>
        )}
        <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2">
          <Link to={ROUTES.USER_PROFILE.replace(":user_id", user?._id)}>
            <ProfileImageComp
              customClass="w-[69px] h-[69px]"
              imageUrl={user?.profile_picture}
              is_opc={user?.memberships?.is_opc}
            />
          </Link>
        </div>
      </div>
      <div className="flex flex-col items-center space-y-2 py-5 mt-4">
        <div className="text-center">
          <div className="text-lg font-semibold text-gray-900">
            {getUserName(user)}
          </div>
          <p className="text-sm text-gray-500">{user?.designation}</p>
        </div>
        <div className="flex space-x-2 mt-1 justify-center">
          <div className="flex items-center text-gray-600 text-sm">
            <div className="flex items-center space-x-1 bg-primary-600 p-1 px-2 rounded-full border border-solid border-primary-200">
              <img
                src="/assets/logo/OneGoldCoin.png"
                alt=""
                className="w-4 h-4"
              />
              <span className="ml-1 text-gray-700">
                {user?.account_balances?.coin || 0}
              </span>
            </div>
          </div>
          <div className="flex items-center text-gray-600 text-sm">
            <div className="flex items-center space-x-1 bg-primary-600 p-1 px-2 rounded-full border border-solid border-primary-200">
              <img
                src="/assets/icons/star-red.png"
                alt=""
                className="w-4 h-4"
              />
              <span className="ml-1 text-gray-700">
                {user?.account_balances?.xp || 0}
              </span>
            </div>
          </div>
        </div>
      </div>

      <div className="flex py-2 text-center ">
        <div className="border-r border-gray-300 text-center flex-1 ">
          <p className="text-[13px] text-gray-500">Posts</p>
          <p className="text-[15px] font-semibold text-gray-900">
            {user?.network?.posts || 0}
          </p>
        </div>
        <div className="border-r border-gray-300 text-center flex-1 ">
          <p className="text-[13px] text-gray-500">Followers</p>
          <p className="text-[15px] font-semibold text-gray-900">
            {user?.network?.followers || 0}
          </p>
        </div>
        <div className=" text-center flex-1 ">
          <p className="text-[13px] text-gray-500">Following</p>
          <p className="text-[15px]  font-semibold text-gray-900">
            {user?.network?.following || 0}
          </p>
        </div>
      </div>
    </div>
  );
};

export default UserLeftBar;
